import useCookieConsent from './hooks/useCookieConsent';
import CookieConsentCustomizeToggles from './components/CookieConsentCustomizeToggles';
import CookieConsentDescription from './components/CookieConsentDescription';
import {
	CookieConsentAcceptAllButton,
	CookieConsentActions,
	CookieConsentBanner,
	CookieConsentBody,
	CookieConsentCustomizeButton,
	CookieConsentRejectButton,
	CookieConsentTitle,
} from './CookieConsent.styles';

const CookieConsent = () => {
	const {
		t,
		hasAnswered,
		isCustomizing,
		choices,
		toggleChoice,
		handleAcceptAll,
		handleSaveSelected,
		handleRejectAll,
		handleCustomize,
	} = useCookieConsent();

	if (hasAnswered) {
		return null;
	}

	return (
		<CookieConsentBanner role='region' aria-label={t.ariaLabel}>
			<CookieConsentBody>
				<CookieConsentTitle>{t.title}</CookieConsentTitle>
				<CookieConsentDescription translations={t} />
			</CookieConsentBody>
			{isCustomizing && (
				<CookieConsentCustomizeToggles
					translations={t}
					choices={choices}
					onToggle={toggleChoice}
				/>
			)}
			<CookieConsentActions>
				<CookieConsentRejectButton type='button' onClick={handleRejectAll}>
					{t.rejectAll}
				</CookieConsentRejectButton>
				<CookieConsentCustomizeButton
					type='button'
					onClick={isCustomizing ? handleSaveSelected : handleCustomize}
				>
					{isCustomizing ? t.saveSelected : t.customize}
				</CookieConsentCustomizeButton>
				<CookieConsentAcceptAllButton type='button' onClick={handleAcceptAll}>
					{t.acceptAll}
				</CookieConsentAcceptAllButton>
			</CookieConsentActions>
		</CookieConsentBanner>
	);
};

export default CookieConsent;
